import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const resetPasswordStart=()=>{
    return {
        type:actionTypes.RESET_PASSWORD_START,
    }
}

export const resetPasswordSuccess=(message)=>{
    return {
        type:actionTypes.RESET_PASSWORD_SUCCESS,
        message:message,
    }
}

export const resetPasswordFail=(error)=>{
    return {
        type:actionTypes.RESET_PASSWORD_FAIL,
        error:error
    }
}

export const clearReset=()=>{
  return {
    type:actionTypes.CLEAR_RESET,
  }
}

export const openResetForm=(resetId)=>{
  return {
    type:actionTypes.OPEN_RESET_FORM,
    id:resetId,
  }
}

export const closeResetForm=()=>{
  return {
    type:actionTypes.CLOSE_RESET_FORM,
  }
}

export const resetPassword=(id,password,token)=>{
    return async dispatch=>{
        dispatch(resetPasswordStart());
        let url = `${api}/users/${id}/resetPassword`;
        const options = {
          url: url,
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`
         },
          data:{
            newPassword:password
          }
        };
        await axios(options)
            .then(response => {
            dispatch(resetPasswordSuccess(`Reset ${response.data.username} success`));
          })
          .catch(err => {
            dispatch(resetPasswordFail(`reset password failed ${err}`));
          });

    }
}

